import React from "react";
import { toJS } from "mobx";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  AreaChart,
  Area,
} from "recharts";

const SquareDot = ({ cx, cy, stroke }) => (
  <rect
    x={cx - 4}
    y={cy - 4}
    width={8}
    height={8}
    fill={stroke}
    stroke={stroke}
  />
);

const AXIS_TICK = { fontSize: 10 };

const getMaxChartValue = (chartData, series) => {
  let max = 0;
  chartData.forEach((point) => {
    series.forEach((s) => {
      const value = Number(point[s.key]) || 0;
      if (value > max) max = value;
    });
  });
  return max;
};

const getYAxisWidth = (maxValue) => {
  if (maxValue >= 1_000_000) return 58;
  if (maxValue >= 100_000) return 52;
  if (maxValue >= 10_000) return 48;
  return 42;
};

export const RechartsLineBarChart = ({
  chartData,
  series,
  type = "line",
  tooltipShared = true,
}) => {
  const plainChartData = toJS(chartData);
  const plainSeries = toJS(series);
  const ChartComponent = type === "bar" ? BarChart : LineChart;
  const SeriesComponent = type === "bar" ? Bar : Line;
  const isDateChart = type === "line";
  const maxValue = getMaxChartValue(plainChartData, plainSeries);
  const yAxisWidth = getYAxisWidth(maxValue);

  return (
    <div className="graph_chart_area">
      <ResponsiveContainer width="100%" height="100%" minHeight={280}>
        <ChartComponent
          data={plainChartData}
          margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: isDateChart ? 55 : 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="label"
            tick={AXIS_TICK}
            angle={isDateChart ? -45 : 0}
            textAnchor={isDateChart ? "end" : "middle"}
            height={isDateChart ? 60 : 30}
            minTickGap={isDateChart ? 4 : undefined}
          />
          <YAxis tick={AXIS_TICK} width={yAxisWidth} />
          <Tooltip shared={tooltipShared} />
          <Legend />
          {plainSeries.map((s) => (
            <SeriesComponent
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.key}
              stroke={s.color}
              fill={s.fill}
              strokeWidth={1}
              isAnimationActive={false}
              // dot={type === "line" ? SquareDot : false}
            >
              {type === "bar" && (
                <LabelList
                  dataKey={s.key}
                  position="top"
                  className="bar_value_label"
                />
              )}
            </SeriesComponent>
          ))}
        </ChartComponent>
      </ResponsiveContainer>
    </div>
  );
};
